import {Graphics} from "@dp-instant/ui";
import * as cancel_icon from "@assets/cancel-icon.svg";
import {IClickableComponentProps} from "@game/ui/interface/IClickableComponentProps";
import cn from "classnames";
import {hapticMedium} from "@game/haptic";

export const CancelButton = ({onClick, ...rest}: IClickableComponentProps) => (
    <button
        className={cn("btn", "btn-red", "cancel-button")}
        {...rest}
        onClick={() => {
            hapticMedium();
            onClick?.();
        }}
        type="button"
    >
        <Graphics svg={cancel_icon} inline={false} />
    </button>
);
